import { IBetaling } from '@/model/IBetaling';
import { AppSingletonPromise } from './AppSingletonPromise';
import { apiClient } from './authenticatedApiClient';

class AppSearchService {
  @AppSingletonPromise
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getBetalingen(force = false): Promise<IBetaling[]> {
    return apiClient.get<IBetaling[]>(`Search/betalingen`).then(response => {
      return response.data;
    });
  }
}

export const appSearchService = new AppSearchService();
